import { inject, Injectable, signal, Signal } from '@angular/core';
import { Country } from '@kinomap-dev/ng-ui-lib/core';
import { ApiService } from './api.service';
import { HttpResourceRef } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  private apiService: ApiService = inject(ApiService);

  countryRessources: HttpResourceRef<Country[] | undefined> = this.apiService.getCountryRessources

  get countries(): Signal<Country[] | undefined> {
    return this.countryRessources.value;
  }

  getFlagUrl(countryCode: string): Signal<string> {
    return signal<string>(`https://flagicons.lipis.dev/flags/4x3/${countryCode.split('-')[0]}.svg`);
  }
}
